<template>
  <div class="get-mobile-app">
    <div class="get-mobile-app__title">
      <img
        class="m-r"
        src="../assets/images/luminary-icon-large.png" >
      <p class="hidden-xs-only">For the best experience, <br > try the Luminary app.</p>
      <p class="hidden-sm-and-up">For the best experience, try the Luminary app.</p>
    </div>
    <div class="get-mobile-app__buttons">
      <el-button
        type="primary"
        @click="onTapDownloadApp"
      >
        Download Free
      </el-button>
      <el-button
        type="text"
        @click="onDenyMobileBanner"
      >
        &#10005;
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onDenyMobileBanner() {
      this.$store.dispatch('denyMobileBanner');
    },
    onTapDownloadApp() {
      this.$emit('onTapDownload');
      const branchBaseLink = process.env.LUMINARY_BRANCH_IO_BASE_LINK;
      window.open(branchBaseLink);
    },
  },
};
</script>

<style lang="scss">
  .get-mobile-app {
    position: fixed;
    left: 50%;
    bottom: 15px;

    font-size: 14px;

    transform: translateX(-50%);

    width: 70%;

    padding: 1rem 2rem;

    box-shadow: 0 0 5px rgba(0, 0, 0, .25);
    background-color: white;
    z-index: 990;

    display: flex;
    align-items: center;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    > div {
      width: 50%;
      display: flex;

      @media (max-width: 767px) {
        width: 100%;
      }
    }

    &__title {
      img {
        height: 40px;
        border-radius: 6px;
      }

      align-items: center;
    }

    &__buttons {
      justify-content: flex-end;
      align-items: center;

      @media (max-width: 767px) {
        margin-top: .5rem;
        justify-content: center;
      }

      .el-button--text {
        font-size: 25px;
        padding: 4px 10px;

        color: #BABABA;

        @media (max-width: 767px) {
          position: absolute;

          top: 2px;
          right: 2px;
        }
      }
    }

    @media (min-width: 1025px) {
      display: none;
    }
  }

  .slide-up-enter,
  .slide-up-leave-to {
    transform: translateY(calc(100% + 70px)) translateX(-50%);
  }

  .slide-up-enter-active, .slide-up-leave-active {
    transition: 250ms ease-out;
  }
</style>



// WEBPACK FOOTER //
// app/src/components/GetMobileApp.vue